<div [formGroup]="parent">
<div class="form-field" [ngClass]="{'has-error': parent.get(controllerData.controlName).touched
&& parent.get(controllerData.controlName).errors}">

  <label for="{{controllerData['name']}}" class="form-label" [id]="'lbl-'+controllerData['label']">{{controllerData['label']}}</label>
  <div class="form-field-text">
  <input [formControlName]="controllerData['controlName']" [name]="controllerData['name']" 
  type="text" [id]="controllerData['name']"
    [(ngModel)]="textValue" aria-invalid="false" 
    [placeholder]="controllerData['placeHolder']" 
    [maxlength]="controllerData['maxlength']"
    class="form-control" [value]="controllerData['value']" 
    [required]="controllerData['required']" 
    (blur)="inputTextChangeHandler($event.target.value)"
     />
     
</div>



<div [id]="controlName +'-error'"  class="form-validation-error"
                *ngIf="parent.get(controlName).touched
                        &&
                    parent.get(controlName).errors">
            <i class="icon icon-error" aria-hidden="true"></i>
            <p *ngIf="parent.get(controlName).touched
                        &&
                      parent.get(controlName).hasError('required')" [id]="controlName +'-error'">{{controllerData['errorMessage']}}</p>
            
        </div>
</div>
</div>
